import { Platform } from 'react-native';

import type { BudgetUser } from '../types/auth';

export type TelemetryLoginMethod = NonNullable<BudgetUser['provider']> | 'unknown';

export type TelemetryPlatform = 'ios' | 'android' | 'web';

export type TelemetryTab = 'Home' | 'Spend' | 'Wealth' | 'Grow' | 'Loan';

export type TelemetryFeature =
  | 'import_open'
  | 'import_start'
  | 'assistant_open'
  | 'spend_alert_save';

export function getTelemetryPlatform(): TelemetryPlatform {
  if (Platform.OS === 'ios') return 'ios';
  if (Platform.OS === 'android') return 'android';
  return 'web';
}

/** Where the user saw or tapped a Pro offer. Used as a GA4 dimension. */
export type PaywallSource =
  | 'settings'
  | 'settings_guest'
  | 'analyze_quota'
  | 'assistant_chat'
  | 'spend_alerts'
  | 'card_due'
  | 'spend_alert_suggestions'
  | 'topbar'
  | 'account_menu'
  | 'landing'
  | 'unknown';

export type PaywallDismissReason = 'not_now' | 'backdrop';

export type CheckoutAbandonResult = 'cancel' | 'dismiss' | 'error';

export type TelemetryUserSnapshot = {
  id: string;
  plan: 'free' | 'pro';
  isPaid: boolean;
  provider: TelemetryLoginMethod;
  subscriptionStatus: string;
};

export function toTelemetryUser(user: BudgetUser): TelemetryUserSnapshot {
  const plan = user.plan === 'pro' ? 'pro' : 'free';
  return {
    id: user.id,
    plan,
    isPaid: plan === 'pro',
    provider: user.provider ?? 'unknown',
    subscriptionStatus: user.subscriptionStatus ?? 'none',
  };
}
